import React from 'react';
import { motion } from 'framer-motion';
interface HeroProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}
const tabs = [{
  id: 'about',
  label: 'About Us'
}, {
  id: 'services',
  label: 'Services'
}, {
  id: 'aesthetics',
  label: 'Medical Aesthetics'
}, {
  id: 'membership',
  label: 'Membership'
}, {
  id: 'contact',
  label: 'Contact Us'
}, {
  id: 'login',
  label: 'Login'
}];
export function Hero({
  activeTab,
  onTabChange
}: HeroProps) {
  return <section className="relative w-full h-screen bg-white overflow-hidden" data-id="element-219">
      {/* Background Image */}
      <motion.div className="absolute inset-0" initial={{
      scale: 1.1,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 1.2,
      ease: 'easeOut'
    }} data-id="element-220">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qddgecT48oxg1burqxbbi6/932e0c386cc1addfc7d5e22fa016cd96.png" alt="NAD+ vials - 5 reasons women love NAD+" className="w-full h-full object-cover object-center" data-id="element-221" />
      </motion.div>

      {/* Content */}
      <div className="relative h-full flex flex-col py-8 md:py-12" data-id="element-222">
        {/* Header - Pushed to top */}
        <motion.header className="flex flex-col space-y-6 px-6" initial={{
        y: -20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: 'easeOut'
      }} data-id="element-223">
          {/* Tabs - Top Row */}
          <nav className="flex justify-center" data-id="element-224">
            <div className="flex flex-wrap justify-center gap-x-4 gap-y-3 md:gap-x-8 xl:gap-x-12 relative" data-id="element-225">
              {tabs.map(tab => <button key={tab.id} onClick={() => onTabChange(tab.id)} className={`text-[10px] md:text-xs tracking-[0.15em] uppercase font-medium transition-colors relative pb-2 ${activeTab === tab.id ? 'text-zinc-950' : 'text-zinc-500 hover:text-zinc-950'}`} data-id="element-226">
                  {tab.label}
                  {activeTab === tab.id && <motion.div layoutId="activeTabHero" className="absolute bottom-0 left-0 right-0 h-px bg-zinc-950" transition={{
                type: 'spring',
                stiffness: 380,
                damping: 30
              }} data-id="element-227" />}
                </button>)}
            </div>
          </nav>

          {/* Logo - Second Row */}
          <div data-id="element-228">
            <button onClick={() => onTabChange('home')} className="text-zinc-950 hover:text-zinc-700 transition-colors text-left" style={{
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-229">
              
            </button>
          </div>
        </motion.header>

        {/* Spacer to push content down */}
        <div className="flex-1" data-id="element-230"></div>

        {/* Hero Content - Pushed down */}
        <div className="pb-32 md:pb-40 px-6" data-id="element-231">
          <div className="max-w-4xl" data-id="element-232">
            <motion.button onClick={() => onTabChange('contact')} className="px-10 py-4 bg-zinc-950 text-white text-sm tracking-[0.2em] uppercase font-medium hover:bg-zinc-800 transition-colors duration-300" initial={{
            y: 20,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} transition={{
            duration: 0.8,
            delay: 0.7,
            ease: 'easeOut'
          }} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} data-id="element-233">
              Book Now
            </motion.button>
          </div>
        </div>

        {/* Scroll Indicator */}
        <motion.div className="pb-12 px-6" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 1.3,
        ease: 'easeOut'
      }} data-id="element-234"></motion.div>
      </div>
    </section>;
}